module.exports = __webpack_public_path__ + "static/media/logo.3d2d0967.png";